export default __webpack_public_path__ + "static/media/boardCustomType.d2488f50.csv";